import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-page-designboxes',
  templateUrl: './page-designboxes.component.html'
})
export class PageDesignboxesComponent implements OnInit {
  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }

}
